import { Injectable } from '@angular/core';
import { UnitDetails } from "../models/unit-details";
import { Details } from '../../details/Interfaces/details';
import { DataFormatter } from '../../common/services/data-formatter.service';
import { LayoutOrientation } from '../../common/enums/layout-orientation';
import { DetailsBuilder } from '@details/Interfaces/details-builder';
import { nameOnly, simple } from '@details/Interfaces/details-item-types';

@Injectable()
export class UnitDetailsMapper {

  constructor() {
  }

    public map(details: UnitDetails, dataFormatter: DataFormatter): Details {

        const b = new DetailsBuilder(`Reference ${details.PropertyRef}/${details.Ref}`, details);

        b.section(`This unit is ${details.OccupationalStatus.toLowerCase()}:`, LayoutOrientation.Vertical)
          .always(nameOnly(details.Name))
          .for('StrungAddress', 'Address:')
          .for('TenantName', `Tenant${!this.isOccupied(details) ? ' was' : ''}:`);

        const breachMessage = details.BreachStatus && details.BreachStatus.toLowerCase() !== 'none'
          ? 'The lease for this Unit is in breach.' : null;

        b.section(`Key information:`, LayoutOrientation.Horizontal)
          .conditionalItem(breachMessage, nameOnly(breachMessage))
          .for('Tenure', `Tenure ${this.isOccupied(details) ? 'is' : 'was'} :`)
          .conditionalItem(details.OccupancyDateFrom != undefined,
            simple(`${this.isOccupied(details) ? 'Occupied' : 'Vacant'} since:`,
              dataFormatter.formatDate(details.OccupancyDateFrom)))
          .always(simple(`${this.isOccupied(details) ? 'Annual rent is' : 'Previous annual rent was'}:`,
            details.PassingRent
            ? `${dataFormatter.formatNumeric(details.PassingRent)} ${details.DefaultCurrencyCode}`
            : 'None'))
          .always(simple(
            `${this.isOccupied(details) ? 'Annual service charge is:' : 'Previous Annual service charge was:'}`,
            details.AnnualSC
            ? `${dataFormatter.formatNumeric(details.AnnualSC)} ${details.DefaultCurrencyCode}`
            : 'None'));

        const formatAsLink = details.CertificateLink != null && (details.CertificateLink.startsWith('https') || details.CertificateLink.startsWith('www.'));
        let certNo = details.CertificateNo == null || details.CertificateNo == '' ? '' :
          details.CertificateNo.substring(0, 4) + ' ' + details.CertificateNo.substring(4, 8) + ' ' + details.CertificateNo.substring(8, 12)
          + ' ' + details.CertificateNo.substring(12, 16) + ' ' + details.CertificateNo.substring(16);
        b.section('Energy Performance:', LayoutOrientation.Horizontal)
          .conditionalItem(details.EpcRatingCode == null, simple('No Current Certificate exists', null))
          .conditionalItem(details.CertificateNo, simple('Certificate No:', certNo))
          .linkForConditionalFormatting(formatAsLink, 'CertificateLink', 'Current Certificate:')
          .conditionalItem(details.EpcRatingCode, simple('Current Rating Code:', details.EpcRatingCode))
          .conditionalItem(details.PotentialRatingCode, simple('Potential Rating:', details.PotentialRatingCode))
          .conditionalItem(details.EpcExpiryDate != null, simple('Expiry Date:', dataFormatter.formatDate(details.EpcExpiryDate)))

        return b.getDetails();
    }


  private isOccupied(unitDetails: UnitDetails): boolean {
    return unitDetails.OccupationalStatus.toLowerCase() !== 'vacant';
  }

}
